const TXT = { verde: "Contract cu fidejusiune semnat la toate 3 firmele", galben: "Contract semnat parțial sau neconfirmat", rosu: "Fără contract semnat" };
const SHORT = { verde: "Contract semnat", galben: "Contract parțial", rosu: "Fără contract" };

export default function BFContractDot({ state = "rosu", label = false, testid }) {
  return (
    <span className={`bf-cdot is-${state}`} title={TXT[state]} data-testid={testid} data-state={state}>
      <i />{label && SHORT[state]}
    </span>
  );
}
